import { createBrowserHistory as createHistory } from 'history'
const history = createHistory()
export default history


// WEBPACK FOOTER //
// ./src/services/history.js